import React, { useContext, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { useTheme } from '../../App';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUser, 
  faSignOutAlt, 
  faUserShield, 
  faSun, 
  faMoon, 
  faBars, 
  faGear
} from '@fortawesome/free-solid-svg-icons';
import './Navbar.css';

function Navbar() {
  const { isAuthenticated, isAdmin, logout, user } = useContext(AuthContext);
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path: string) => {
    return location.pathname === path ? 'active' : '';
  };
  
  return (
    <nav className={`navbar navbar-expand-lg ${theme === 'light' ? 'navbar-light bg-light' : 'navbar-dark bg-primary'} shadow-sm sticky-top`}>
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center logo-container" to="/" onClick={closeMenu}>
          <div className="logo-wrapper">
          <img 
            src={theme === 'light' ? '/logo.svg' : '/logo_light.svg'} 
            alt="Nodesail" 
              width="160"
              height="16" 
            className="logo-image"
          />
                          <span className="beta-text">support</span>
          </div>
        </Link>
        <button 
          className="navbar-toggler" 
          type="button" 
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
        <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav me-auto">
            {isAuthenticated && (
              <>
                {isAdmin && (
                  <li className="nav-item">
                    <Link 
                      className={`nav-link ${isActive('/admin')}`} 
                      to="/admin"
                      onClick={closeMenu}
                    >
                      <FontAwesomeIcon icon={faUserShield} className="me-1" />
                      Admin
                    </Link>
                  </li>
                )}
              </>
            )}
          </ul>
          
          {/* Right section with theme toggle and auth buttons */}
          <div className="ms-auto d-flex align-items-center">
            <button 
              className="theme-toggle nav-link me-3" 
              onClick={toggleTheme}
              title={`Currently using ${localStorage.getItem('theme') ? 'user-selected' : 'system'} theme. Click to toggle. Double-click quickly to reset to system theme.`}
              aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
              data-theme-source={localStorage.getItem('theme') ? 'user' : 'system'}
            >
              <FontAwesomeIcon icon={theme === 'light' ? faMoon : faSun} />
              {!localStorage.getItem('theme') && <span className="theme-indicator"></span>}
            </button>
            
            {isAuthenticated && (
              <ul className="navbar-nav">
                <li className="nav-item dropdown">
                  <button 
                    className="nav-link dropdown-toggle px-3" 
                    id="navbarDropdown" 
                    data-bs-toggle="dropdown" 
                    aria-expanded="false"
                  >
                    <FontAwesomeIcon icon={faUser} className="me-2" />
                    {user?.name}
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                    <li>
                      <Link 
                        className="dropdown-item" 
                        to="/profile"
                        onClick={closeMenu}
                      >
                        <FontAwesomeIcon icon={faUser} className="me-2" />
                        Profile
                      </Link>
                    </li>
                    <li>
                      <Link 
                        className="dropdown-item" 
                        to="/profile/change-password"
                        onClick={closeMenu}
                      >
                        <FontAwesomeIcon icon={faGear} className="me-2" />
                        Change Password
                      </Link>
                    </li>
                    <li><hr className="dropdown-divider" /></li>
                    <li>
                      <button 
                        className="dropdown-item" 
                        onClick={() => {
                          handleLogout();
                          closeMenu();
                        }}
                      >
                        <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                        Logout
                      </button>
                    </li>
                  </ul>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;